// extracted by mini-css-extract-plugin
export default {"selector":"vca","disabled":"wca","hed":"xca","selected":"yca","subHed":"zca","standard":"Aca","flavor":"Bca","flavorImage":"Cca","long":"Eca"};
    if(module.hot) {
      // 1726593108479
      var cssReload = require("../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  